import { isRouteErrorResponse } from "react-router";

import { ErrorBoundary as AppErrorBoundary } from "~/components/ErrorBoundary";
import { NotFoundPage } from "~/components/NotFoundPage";
import { CategoriesLayout as AppCategoriesLayout } from "~/feature/categories/layouts/CategoriesLayout";
import { loadCategories } from "~/loaders/categories";

import type { Route } from "./+types/categoriesLayout";

export async function loader() {
  try {
    return { categories: await loadCategories() };
  } catch (e) {
    console.error(e);

    return { categories: [] };
  }
}

export default function CategoriesLayout({ loaderData }: Route.ComponentProps) {
  return <AppCategoriesLayout categories={loaderData.categories} />;
}

export function ErrorBoundary({ error, loaderData }: Route.ErrorBoundaryProps) {
  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <AppCategoriesLayout categories={loaderData?.categories ?? []}>
        <NotFoundPage />
      </AppCategoriesLayout>
    );
  }

  return <AppErrorBoundary error={error} />;
}
